/**
 * Bumpers native cart drawer (draft proposal 31.10.2026). No app, no monthly fee.
 * Ajax API only: /cart/add.js, /cart/change.js, /cart/update.js (discount codes), Section Rendering (?sections=bumpers-cart).
 * Same public API as Dawn's <cart-drawer>: open(), close(), renderContents(parsed), getSectionsToRender(), setActiveElement().
 */
(function () {
  if (customElements.get('cart-drawer')) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTIONS = 'bumpers-cart,cart-icon-bubble';
  var RECS_MAX = 4;
  /* 2.11.2026 (Gal GO): English UI strings on non-Hebrew locales; Hebrew unchanged. */
  var HE = /^he/i.test(document.documentElement.lang || 'he');
  function T(he, en) { return HE ? he : en; }
  var recCache = {};
  /* 1.11.2026 live: Ego (Opus) cart app guard. While the Ego app embed is on, Ego owns the cart and this drawer stays silent.
     Once the Ego embed is switched off in the theme editor, its scripts disappear from the page and this drawer takes over automatically. */
  function egoOn() {
    return !!(document.getElementById('opus-script-v1') || document.getElementById('opus-script-v2') ||
      document.querySelector('script[src*="/opus-cart-drawer"]'));
  }
  /* 1.11.2026 15:10 fallback: Ego scripts can be on the page while Ego does not open (e.g. right after the embed is switched off, or Ego inactive).
     So when Ego is present we wait for Ego to actually open; if it has not opened within EGO_WAIT ms, this drawer opens instead.
     If Ego opens while this drawer is open, this drawer closes, so there is never more than one cart on screen. */
  var EGO_WAIT = 2500, EGO_ICON_WAIT = 700;
  function egoOpen() { return !!(document.body && document.body.classList.contains('opus-modal-open')); }
  window.BumpersCartEgo = egoOn;

  function money(c) {
    c = Number(c) || 0;
    return (c % 100 === 0 ? String(c / 100) : (c / 100).toFixed(2)) + ' ₪';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function postJSON(url, body) {
    return fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw j;
        return j;
      });
    });
  }

  class BumpersCart extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.panel = this.querySelector('.bc__panel');
      this.live = this.querySelector('[data-bc-live]');
      var foot = this.querySelector('[data-bc-main-slot] [data-bc-foot]');
      if (foot) this.querySelector('[data-bc-foot-inner]').appendChild(foot);
      this.readState();

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKey.bind(this));
      this.querySelector('[data-bc-coupon-form]').addEventListener('submit', this.onCoupon.bind(this));

      var self = this;
      var icon = document.getElementById('cart-icon-bubble');
      if (icon) {
        icon.setAttribute('role', 'button');
        icon.setAttribute('aria-haspopup', 'dialog');
        icon.setAttribute('aria-controls', 'BumpersCart');
        /* 1.11 15:50: always handled here; if Ego is present it gets EGO_ICON_WAIT ms to open, otherwise this drawer opens. href=/cart stays as the no-JS fallback. */
        icon.addEventListener('click', function (e) { e.preventDefault(); self.openOrDefer(icon, false, EGO_ICON_WAIT); });
        icon.addEventListener('keydown', function (e) {
          if (e.code && e.code.toUpperCase() === 'SPACE') { e.preventDefault(); self.openOrDefer(icon, false, EGO_ICON_WAIT); }
        });
      }
      /* Sticky ATC block + other theme code fire these. */
      document.addEventListener('cart:open', function () { self.openOrDefer(); });
      if (document.body) new MutationObserver(function () { if (egoOpen() && self.isOpen) self.close(); }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('cart:refresh', function () { self.refresh(); });
      window.addEventListener('pageshow', function (e) { if (e.persisted) self.refresh(); });
      window.addEventListener('resize', function () { if (self.isOpen) self.placeA11y(); });
    }

    /* ---------- Dawn-compatible API ---------- */
    getSectionsToRender() {
      return [{ id: 'bumpers-cart' }, { id: 'cart-icon-bubble' }];
    }
    setActiveElement(el) { this.activeElement = el; }
    renderContents(parsed) {
      if (egoOn()) { if (parsed && parsed.sections && parsed.sections['bumpers-cart']) this.apply(parsed.sections); this.openOrDefer(null, true); return; }
      if (parsed && parsed.sections && parsed.sections['bumpers-cart']) {
        this.apply(parsed.sections);
        this.open(null, true);
        this.peek();
      } else {
        this.open();
      }
    }

    peek() {
      var p = this.querySelector('[data-bc-peek]');
      if (!p || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
      p.classList.remove('is-peek'); void p.offsetWidth; p.classList.add('is-peek');
      setTimeout(function () { p.classList.remove('is-peek'); }, 1300);
    }
    /* ---------- open / close ---------- */
    openOrDefer(trigger, skipRefresh, wait) {
      if (!egoOn()) { this.open(trigger, skipRefresh); return; }
      var self = this, t0 = Date.now();
      clearTimeout(this._egoT);
      (function poll() {
        if (egoOpen()) return;
        if (Date.now() - t0 >= (wait || EGO_WAIT)) { self._force = true; self.open(trigger, skipRefresh); self._force = false; return; }
        self._egoT = setTimeout(poll, 100);
      })();
    }
    open(trigger, skipRefresh) {
      if (egoOn() && !this._force) return;
      if (egoOpen()) return;
      if (trigger) this.setActiveElement(trigger);
      else if (!this.activeElement) this.setActiveElement(document.activeElement);
      if (!skipRefresh) this.refresh();
      if (this.isOpen) return;
      this.isOpen = true;
      this.hidden = false;
      var self = this;
      setTimeout(function () {
        self.classList.add('is-open');
        document.documentElement.classList.add('bc-lock');
        document.body.classList.add('bc-open');
        setTimeout(function () {
          var c = self.querySelector('.bc__close');
          (c || self.panel).focus({ preventScroll: true });
          self.placeA11y();
        }, 260);
        self.scheduleA11y();
      }, 20);
      this.loadRecs();
    }
    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('bc-lock');
      document.body.classList.remove('bc-open');
      this.restoreA11y();
      var self = this;
      setTimeout(function () { if (!self.isOpen) self.hidden = true; }, 300);
      if (this.activeElement && this.activeElement.focus && document.contains(this.activeElement)) {
        try { this.activeElement.focus({ preventScroll: true }); } catch (e) {}
      }
    }

    /* ---------- events ---------- */
    onKey(e) {
      if (e.key === 'Escape') {
        if (e.target.closest && e.target.closest('details[open]') && e.target.tagName === 'INPUT') e.target.closest('details').open = false;
        this.close();
        return;
      }
      if (e.key !== 'Tab' || !this.isOpen) return;
      var f = Array.prototype.filter.call(
        this.panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),summary,[tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null || el === document.activeElement; }
      );
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    onClick(e) {
      var t = e.target;
      if (t.closest('[data-bc-close]')) { e.preventDefault(); this.close(); return; }
      var item = t.closest('.bc-item');
      if (t.closest('[data-bc-remove]') && item) { this.change(item.dataset.key, 0); return; }
      var q = t.closest('[data-bc-qty]');
      if (q && item) { this.change(item.dataset.key, Math.max(0, Number(item.dataset.qty) + Number(q.dataset.bcQty))); return; }
      var rm = t.closest('[data-bc-code-remove]');
      if (rm) { var chip = rm.closest('[data-code]'); this.setCodes(this.codes().filter(function (c) { return c !== chip.dataset.code; }), null); return; }
      var size = t.closest('[data-bc-size]');
      if (size) { this.pickSize(size); return; }
      var add = t.closest('[data-bc-rec-add]');
      if (add) { this.addRec(add); return; }
      if (t.closest('[data-bc-checkout]')) { this.busy(true); }
    }

    /* ---------- state + rendering ---------- */
    readState() {
      var s = this.querySelector('[data-bc-state]');
      try { this.state = JSON.parse(s.textContent); } catch (e) { this.state = { count: 0, total: 0, ids: [], codes: [] }; }
      this.state.codes = (this.state.codes || []).filter(Boolean);
      this.classList.toggle('is-empty', !this.state.count);
      var cnt = this.querySelector('[data-bc-count]');
      if (cnt) cnt.textContent = this.state.count ? '(' + this.state.count + ')' : '';
    }
    codes() { return (this.state && this.state.codes) || []; }
    apply(sections) {
      var html = sections['bumpers-cart'];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-bc-main]', '[data-bc-foot]'].forEach(function (sel) {
          var n = doc.querySelector(sel), o = this.querySelector(sel);
          if (n && o) o.replaceWith(n);
        }, this);
        this.readState();
      }
      var bubble = sections['cart-icon-bubble'], icon = document.getElementById('cart-icon-bubble');
      if (bubble && icon) {
        var b = new DOMParser().parseFromString(bubble, 'text/html').querySelector('.shopify-section');
        if (b) icon.innerHTML = b.innerHTML;
      }
      this.loadRecs();
      /* keep keyboard focus inside the drawer when the focused button was re-rendered */
      if (this.isOpen && (!document.activeElement || document.activeElement === document.body || !this.contains(document.activeElement))) {
        var c = this.querySelector('.bc__close'); if (c) c.focus({ preventScroll: true });
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'bumpers-cart' } }));
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bumpers-cart' }); } catch (e) {}
      }
    }
    refresh() {
      var self = this;
      return fetch(ROOT + '?sections=' + SECTIONS, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (s) { self.apply(s); })
        .catch(function () {});
    }
    busy(on) { this.classList.toggle('is-busy', !!on); }
    say(msg) { if (this.live) { this.live.textContent = ''; var l = this.live; setTimeout(function () { l.textContent = msg; }, 50); } }
    flash(msg) {
      var main = this.querySelector('[data-bc-main]');
      var p = document.createElement('p');
      p.className = 'bc-error'; p.setAttribute('role', 'alert'); p.textContent = msg;
      if (main) main.insertBefore(p, main.firstChild);
      setTimeout(function () { p.remove(); }, 5000);
    }

    change(key, qty) {
      var self = this;
      this.busy(true);
      return postJSON('cart/change.js', { id: key, quantity: qty, sections: SECTIONS, sections_url: location.pathname })
        .then(function (c) { self.apply(c.sections); self.say(qty === 0 ? T('המוצר הוסר מהסל', 'Item removed from cart') : T('הכמות עודכנה', 'Quantity updated')); })
        .catch(function (err) { self.refresh().then(function () { self.flash((err && (err.description || err.message)) || T('לא הצלחנו לעדכן את הסל, נסו שוב', 'We couldn\'t update your cart, please try again')); }); })
        .finally(function () { self.busy(false); });
    }

    /* ---------- coupon (Ajax API: /cart/update.js {discount}) ---------- */
    onCoupon(e) {
      e.preventDefault();
      var input = e.target.querySelector('input');
      var code = (input.value || '').trim();
      if (!code) { this.couponMsg(T('נא להזין קוד', 'Please enter a code'), false); input.focus(); return; }
      var list = this.codes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
      list.push(code);
      this.setCodes(list, code);
    }
    couponMsg(msg, ok) {
      var m = this.querySelector('[data-bc-coupon-msg]');
      m.textContent = msg; m.className = 'bc-coupon__msg' + (ok === true ? ' is-ok' : ok === false ? ' is-bad' : '');
    }
    setCodes(list, tried) {
      var self = this;
      this.busy(true);
      return postJSON('cart/update.js', { discount: list.join(','), sections: SECTIONS, sections_url: location.pathname })
        .then(function (c) {
          var dc = c.discount_codes || [];
          var bad = dc.filter(function (d) { return !d.applicable; }).map(function (d) { return d.code; });
          if (bad.length) {
            /* drop codes that don't apply, so checkout gets only working codes */
            return postJSON('cart/update.js', {
              discount: dc.filter(function (d) { return d.applicable; }).map(function (d) { return d.code; }).join(','),
              sections: SECTIONS, sections_url: location.pathname
            }).then(function (c2) {
              self.apply(c2.sections);
              var details = self.querySelector('[data-bc-coupon]'); if (details) details.open = true;
              self.couponMsg(T('הקוד ' + bad.join(', ') + ' לא תקף לסל הזה', 'Code ' + bad.join(', ') + ' isn\'t valid for this cart'), false);
            });
          }
          self.apply(c.sections);
          if (tried) {
            var input = self.querySelector('#BumpersCart-code'); if (input) input.value = '';
            self.couponMsg(T('הקוד ' + tried + ' הופעל ✓', 'Code ' + tried + ' applied ✓'), true);
          } else self.couponMsg(T('הקוד הוסר', 'Code removed'), null);
        })
        .catch(function () { self.couponMsg(T('לא הצלחנו לבדוק את הקוד, נסו שוב', 'We couldn\'t check the code, please try again'), false); })
        .finally(function () { self.busy(false); });
    }

    /* ---------- upsell: Shopify product recommendations, never items already in the cart ---------- */
    loadRecs() {
      var box = this.querySelector('[data-bc-recs]');
      var ids = (this.state && this.state.ids) || [];
      if (!box) return;
      if (!ids.length) { box.hidden = true; return; }
      var seed = ids[0], self = this;
      var got =
        (window.BumpersRecs ? window.BumpersRecs.pick({ seedTypes: (this.state && this.state.types) || [], excludeIds: ids, max: 10 }) : Promise.resolve([]));
      got.then(function (list) {
        var inCart = ((self.state && self.state.ids) || []).map(String);
        var picks = list.filter(function (p) {
          return inCart.indexOf(String(p.id)) === -1 && p.price > 0 && p.variants && p.variants.length;
        }).slice(0, RECS_MAX);
        var key = picks.map(function (p) { return p.id; }).join(',');
        if (key === self._recKey && !box.hidden) return;
        self._recKey = key;
        if (!picks.length) { box.hidden = true; return; }
        var hadFocus = box.contains(document.activeElement);
        self.querySelector('[data-bc-recs-track]').innerHTML = picks.map(self.recCard).join('');
        box.hidden = false;
        if (self.isOpen && (hadFocus || document.activeElement === document.body)) { var c = self.querySelector('.bc__close'); if (c) c.focus({ preventScroll: true }); }
      }).catch(function () { box.hidden = true; });
    }
    recCard(p) {
      var vs = p.variants, v0 = vs[0];
      var single = p.single || (vs.length === 1 && /default/i.test(v0.title));
      var R = window.BumpersRecs;
      var sizes = single ? '' :
        '<div class="bc-rec__sizes" role="radiogroup" aria-label="' + T('בחירת מידה ל', 'Choose size for ') + esc(p.title) + '">' +
        vs.map(function (v) {
          return '<button type="button" role="radio" aria-checked="false" class="bc-size" data-bc-size data-id="' + v.id + '" data-p="' + v.price + '" data-c="' + v.compare_at_price + '">' + esc(v.title) + '</button>';
        }).join('') + '</div>';
      return '<article class="bc-rec" role="listitem" data-id="' + p.id + '">' +
        '<a class="bc-rec__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(p.img || '') + '" alt="" width="76" height="76" loading="lazy"></a>' +
        '<div class="bc-rec__info"><a class="bc-rec__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<p class="bc-rec__price brx-price">' + R.priceHtml(v0.price, v0.compare_at_price || p.compare_at_price) + '</p>' + sizes +
        '<button type="button" class="bc-btn bc-btn--rec" data-bc-rec-add' + (single ? ' data-id="' + v0.id + '"' : ' disabled') + '>' +
        (single ? T('הוספה לסל', 'Add to cart') : T('בחרו מידה', 'Choose size')) + '</button><p class="bc-rec__err" role="alert"></p></div></article>';
    }
    pickSize(btn) {
      var card = btn.closest('.bc-rec');
      card.querySelectorAll('[data-bc-size]').forEach(function (b) {
        var on = b === btn; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var add = card.querySelector('[data-bc-rec-add]');
      add.dataset.id = btn.dataset.id; add.disabled = false; add.textContent = T('הוספה לסל · מידה ', 'Add to cart · Size ') + btn.textContent;
      var pr = card.querySelector('.bc-rec__price'); if (pr && window.BumpersRecs && btn.dataset.p) pr.innerHTML = window.BumpersRecs.priceHtml(Number(btn.dataset.p), Number(btn.dataset.c));
    }
    addRec(btn) {
      if (!btn.dataset.id) return;
      var self = this, card = btn.closest('.bc-rec');
      this.busy(true);
      postJSON('cart/add.js', { items: [{ id: Number(btn.dataset.id), quantity: 1 }], sections: SECTIONS, sections_url: location.pathname })
        .then(function (c) { self.apply(c.sections); self.say(T('המוצר נוסף לסל', 'Item added to cart')); self.peek(); var s = self.querySelector('[data-bc-scroll]'); if (s) s.scrollTo({ top: 0, behavior: 'smooth' }); })
        .catch(function (err) { var e = card && card.querySelector('.bc-rec__err'); if (e) e.textContent = (err && err.description) || T('לא הצלחנו להוסיף, נסו שוב', 'We couldn\'t add it, please try again'); })
        .finally(function () { self.busy(false); });
    }

    /* ---------- UserWay accessibility button: move into the drawer header slot while open (never over the total) ---------- */
    placeA11y() {
      var w = document.querySelector('.userway_buttons_wrapper');
      var slot = this.querySelector('[data-bc-a11y-slot]');
      if (!w || !slot || !this.isOpen) return;
      var s = slot.getBoundingClientRect();
      if (!s.width || !s.height) return;
      if (!w.hasAttribute('data-bc-moved')) {
        w.setAttribute('data-bc-style', w.getAttribute('style') || '');
        w.setAttribute('data-bc-moved', '1');
      }
      /* v2 2.11: anchor from the top with absolute viewport coordinates (no transform math, no transition),
         so a mid-animation measurement or a mobile toolbar resize can never push it off-screen or low. */
      var st = w.style;
      st.setProperty('transition', 'none', 'important');
      st.setProperty('transform', 'none', 'important');
      st.setProperty('bottom', 'auto', 'important');
      st.setProperty('right', 'auto', 'important');
      st.setProperty('margin', '0', 'important');
      var r = w.getBoundingClientRect();
      var bw = r.width || 44, bh = r.height || 44;
      var top = Math.max(0, Math.round(s.top + (s.height - bh) / 2));
      var left = Math.max(0, Math.min(window.innerWidth - bw, Math.round(s.left + (s.width - bw) / 2)));
      st.setProperty('position', 'fixed', 'important');
      st.setProperty('top', top + 'px', 'important');
      st.setProperty('left', left + 'px', 'important');
    }
    scheduleA11y() {
      var self = this;
      if (this._a11yT) this._a11yT.forEach(clearTimeout);
      requestAnimationFrame(function () { self.placeA11y(); });
      this._a11yT = [100, 300, 600, 900, 1500].map(function (ms) { return setTimeout(function () { self.placeA11y(); }, ms); });
      if (!this._a11yVV && window.visualViewport) {
        this._a11yVV = true;
        window.visualViewport.addEventListener('resize', function () { if (self.isOpen) self.placeA11y(); });
      }
    }
    restoreA11y() {
      if (this._a11yT) { this._a11yT.forEach(clearTimeout); this._a11yT = null; }
      var w = document.querySelector('.userway_buttons_wrapper[data-bc-moved]');
      if (w) {
        var old = w.getAttribute('data-bc-style');
        if (old) w.setAttribute('style', old); else w.removeAttribute('style');
        w.removeAttribute('data-bc-moved'); w.removeAttribute('data-bc-style');
      }
    }
  }

  customElements.define('cart-drawer', BumpersCart);
})();
